import React from 'react';
import PreLoginPage from '../../views/core/PreLoginPage';
// ES6 class-style
class HomeworkHighlights extends PreLoginPage {
    constructor(props) {
        super(props);
    };

componentDidMount(){
    //console.log("Overall Features ",this.props)
}
render(){
    return(
        <div id="HomeworkHighlights">
            <div className="container">			
                <div className="row">
                    <h2>{this.rb("homework.highlights.title")}</h2>
                    <h2>{this.rb("homework.highlights.title1")}</h2>
                    <div className="col-sm-6 col-md-6 col-lg-3 featureSection">
                        <img src={"/img/benifits1.png"} alt="Diagnostic test report" />
                        {/* <h3 className="heading-three">{this.rb("homework.benefits1")}</h3> */}
                        {/* <p>2000+ animated lessons, games and interactive tools and a Question Bank of 100,000+ problems.</p> */}
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-3 featureSection">
                        <img src={"/img/benifits2.png"} alt="Video lesson" />
                        {/* <h3 className="heading-three">{this.rb("homework.benefits2")}</h3> */}
                        {/* <p>Provide differentiated and personalized learning for students and track their progress through detailed Dashboard.</p> */}
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-3 featureSection">
                        <img src={"/img/benifits3.png"} alt="Man holding bow and arrow" />
                        {/* <h3 className="heading-three">{this.rb("homework.benefits3")}</h3> */}
                        {/* <p>To gain an immersive exposure to digital content creation and technology skills (web and mobile apps)</p> */}
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-3 featureSection">
                        <img src={"/img/benifits4.png"} alt="Granular report card" />
                        {/* <h3 className="heading-three">{this.rb("homework.benefits4")}</h3> */}
                        {/* <p>Incorporates Singapore’s model method, and diverse approaches for an inclusive classroom</p> */}
                    </div>
                </div>
            </div>
        </div>
    )
}
}

export default HomeworkHighlights;


// WEBPACK FOOTER //
// ./src/vendors/homework/HomeworkHighlights.js